/**
 * Small display formatters for the results screens. Dates render in the user's locale; numerics stay
 * LTR (the caller wraps them in nv-mono nv-ltr-island). No business logic here — display only.
 */
import type { Locale } from "@/app";

/** A short, locale-aware date-time (falls back to the raw string on a bad value). */
export function formatDateTime(iso: string | null | undefined, locale: Locale): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const tag = locale === "ar" ? "ar-DZ" : "fr-DZ";
  try {
    return new Intl.DateTimeFormat(tag, { dateStyle: "medium", timeStyle: "short" }).format(d);
  } catch {
    return d.toISOString();
  }
}

/** Truncate a long opaque token (signature hash) for inline display. */
export function shortHash(hash: string | null | undefined): string {
  if (!hash) return "—";
  return hash.length > 16 ? `${hash.slice(0, 8)}…${hash.slice(-8)}` : hash;
}

/** Keep only digits — guards the id-lookup inputs (ids are numeric BigInts server-side). */
export function digitsOnly(raw: string): string {
  return raw.replace(/[^\d]/g, "");
}
